export const PERMS = {
    READ: 'report_trailer_fuelings.read',
    EXPORT: 'report_trailer_fuelings.export',
}
